import { render, staticRenderFns } from "./holiday-action-column.vue?vue&type=template&id=f0866f96"
import script from "./holiday-action-column.vue?vue&type=script&lang=js"
export * from "./holiday-action-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports